import { Map } from 'immutable';
import React from 'react';
import { connect } from 'react-redux';

import WindowSizeHOC from '@sophocles/components/WindowSizeHOC';
import { issueCategorySelector } from '@sophocles/entities/IssueCategory';
import { fetchAllIssues, issueSubCategorySelector } from '@sophocles/entities/IssueSubCategory';
import { windowSizes } from '@sophocles/utils';

const selectStyle = {
  height: '31px',
  padding: '3px 7px',
  borderRadius: '4px',
  border: '1px solid #a6a6a6',
  borderTopColor: '#949494',
  width: '100%',
  fontSize: '14px',
  backgroundColor: 'var(--surface-primary)',
  backgroundImage: 'none',
  backgroundClip: 'padding-box',
  color: 'var(--text-secondary)',
  lineHeight: 1.25,
};

class IssueCategorySelectComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = { category: 4, subCategory: 2 }; // set default to Other/Undetermined Issue / Other
  }

  componentDidMount() {
    const { fetchIssueCategories } = this.props;
    fetchIssueCategories();
  }

  handleChangeCategory = event => {
    const { onChange, subCategories, category, categories } = this.props;
    const { value } = event.currentTarget;
    const eligibleForRma = categories.find(entry => entry.get('id', 0) == value, Map()).get('eligible_for_rma', false);
    if (value != category) {
      const selectedSubCategory =
        value != null
          ? subCategories
              .filter(sub => !sub.get('obsolete') && sub.get('category', 0) == value)
              .toList()
              .sortBy(x => x.get('name'))
              .first()
              .get('id', 0)
          : null;
      onChange(value, selectedSubCategory, eligibleForRma);
      // this.setState({category: value, subCategory: selectedSubCategory });
    }
  };

  handleChangeSubCategory = event => {
    const { onChange, category, categories } = this.props;
    const { value } = event.currentTarget;
    const eligibleForRma = categories
      .find(entry => entry.get('id', 0) == category, Map())
      .get('eligible_for_rma', false);
    onChange(category, value, eligibleForRma);
  };

  render() {
    const { categories, subCategories, category, subCategory, onlyShowRmaCategories, windowWidth } = this.props;

    const onMobile = windowWidth <= windowSizes.mobile.width;

    const nonObsoleteSubCategories = subCategories.filter(
      entry => !entry.get('obsolete', false) || subCategory == entry.get('id', 0),
    );
    const nonObsoleteCategories = categories.filter(
      entry =>
        (!entry.get('obsolete', false) || category == entry.get('id', 0)) &&
        nonObsoleteSubCategories.some(sub => sub.get('category') == entry.get('id')),
    );
    // rma filter
    const filteredCategories = onlyShowRmaCategories
      ? // only show eligible_for_rma == true and not obsolete, or if somehow the category isn't one of those... also show that category for sanity.
        nonObsoleteCategories.filter(entry => entry.get('eligible_for_rma', false) || category == entry.get('id', 0))
      : // show all categories
        nonObsoleteCategories;

    const filteredSubCategories = nonObsoleteSubCategories.filter(entry => entry.get('category') == category);

    return (
      <div style={{ display: onMobile ? null : 'flex', alignItems: 'center' }}>
        <div style={{ fontSize: '14px', marginBottom: '8px', paddingRight: '16px' }}>
          <label style={{ margin: 0, fontWeight: 'bold', color: 'var(--text-primary)' }}>Category</label>
          <select
            style={selectStyle}
            name="issue_category"
            value={category || ''}
            onChange={this.handleChangeCategory}
            // inputProps={{ style: {height:'31px', padding:'3px 7px', borderRadius:'4px', border: '1px solid #a6a6a6', borderTopColor:'#949494', width:'100%'} }}
            // autoWidth={true}
          >
            {filteredCategories
              .toList()
              .sortBy(item => item.get('name'))
              .map(item => (
                <option key={item.get('id', 0)} value={item.get('id', 0)}>
                  {item.get('name', '')}
                  {item.get('obsolete') ? ' - old' : null}
                </option>
              ))}
          </select>
        </div>
        <div style={{ fontSize: '14px', marginBottom: '8px', paddingRight: '16px' }}>
          <label style={{ margin: 0, fontWeight: 'bold', color: 'var(--text-primary)' }}>Sub Category</label>
          <select
            style={selectStyle}
            name="issue_sub_category"
            value={subCategory || ''}
            onChange={this.handleChangeSubCategory}
            // inputProps={{ style: {height:'31px', padding:'3px 7px', borderRadius:'4px', border: '1px solid #a6a6a6', borderTopColor:'#949494', width:'100%'} }}
            // autoWidth={true}
          >
            {filteredSubCategories.isEmpty() ? (
              <option value="" />
            ) : (
              filteredSubCategories
                .toList()
                .sortBy(item => item.get('name'))
                .map(item => (
                  <option key={item.get('id', 0)} value={item.get('id', 0)}>
                    {item.get('name', '')}
                    {item.get('obsolete') ? ' - old' : null}
                  </option>
                ))
            )}
          </select>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    // user: getAuthUserWithOptionsAndSubscriptions(state),
    categories: issueCategorySelector(state),
    subCategories: issueSubCategorySelector(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    // doGoBack: (route) => dispatch(goBack()),
    fetchIssueCategories: () => dispatch(fetchAllIssues()),
  };
}

const IssueCategorySelectContainer = connect(mapStateToProps, mapDispatchToProps)(IssueCategorySelectComponent);

export default WindowSizeHOC(IssueCategorySelectContainer);
